import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [toast, setToast] = useState({ message: "", show: false });

  const navigate = useNavigate();

  const showToast = (message) => {
    setToast({ message, show: true });
    setTimeout(() => setToast({ message: "", show: false }), 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("http://193.123.94.90/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("role", data.role);
        showToast("✅ Login successful!");

        if (data.user["role"] === "student") {
          navigate("/profile/student");
        } else if (data.user["role"] === "teacher") {
          navigate("/profile/teacher");
        } else {
          navigate("/dashboard");
        }
      } else {
        showToast("❌ Invalid email or password.");
      }
    } catch (error) {
      console.error("Error logging in:", error);
      showToast("🚫 Something went wrong. Please try again.");
    }
  };

  return (
    <div
      className="position-relative d-flex justify-content-center align-items-center min-vh-100"
      style={{ backgroundColor: "#ffeae9", overflow: "hidden" }}
    >
      <div
        style={{
          backgroundImage: "url('/background.jpg')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          opacity: 0.08,
          position: "absolute",
          inset: 0,
          zIndex: 0,
        }}
      ></div>

      {/* Toast */}
      {toast.show && (
        <div
          className="position-absolute top-0 start-50 translate-middle-x mt-3 px-4 py-2 rounded shadow"
          style={{
            backgroundColor: "#fff0f0",
            color: "#c03b3b",
            zIndex: 1000,
            border: "1px solid #f5b5b5",
          }}
        >
          {toast.message}
        </div>
      )}

      <div
        className="bg-white rounded-4 shadow p-5 w-100 position-relative"
        style={{ maxWidth: "480px", zIndex: 1 }}
      >
        <h2 className="text-center mb-4">Welcome Back!</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              id="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              id="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn btn-peach w-100 mt-3">Login</button>
        </form>

        <p className="text-center mt-3">
          <Link to="/">Go to Home</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
